/* eslint-disable no-param-reassign */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import Cookies from "js-cookie";
import { set as sessionStorageSet, get as sessionStorageGet } from "../../storage";
var WEBGL_RENDERER_KEY = "WEBGL_RENDERER";
var storage = function _() {
    try {
        return localStorage;
    } catch (err) {
        return {};
    }
}();
var parseQueryString = function() {
    // Use location.search to access query string instead
    var qs = window.location.search.substring(1);
    var items = qs.split("&");
    // Consider using reduce to create the data mapping
    return items.reduce(function(data, item) {
        var _item_split = _sliced_to_array(item.split("="), 2), key = _item_split[0], value = _item_split[1];
        if (data[key] !== undefined) {
            if (!Array.isArray(data[key])) {
                data[key] = [
                    data[key]
                ];
            }
            data[key].push(value);
        } else {
            data[key] = value;
        }
        return data;
    }, {});
};
var getWebGLRenderer = function() {
    var renderer = sessionStorageGet(WEBGL_RENDERER_KEY);
    if (renderer) {
        return {
            renderer: renderer
        };
    }
    var gl = window.document.createElement("canvas").getContext("webgl");
    if (!gl) {
        return {
            error: "no webgl"
        };
    }
    var debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    if (debugInfo) {
        var rendererWebGL = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        sessionStorageSet(WEBGL_RENDERER_KEY, rendererWebGL);
        return {
            renderer: rendererWebGL
        };
    }
    return {
        error: "no WEBGL_debug_renderer_info"
    };
};
var getOrientation = function(orientation) {
    if (orientation) {
        if (orientation.type) {
            return orientation.type.split("-")[0];
        }
        return null;
    }
    var _window_screen = window.screen, width = _window_screen.width, height = _window_screen.height;
    return width > height ? "landscape" : "portrait";
};
var getContext = function() {
    if (!window) return null;
    var navigator = window.navigator, document = window.document, screen = window.screen, location = window.location;
    var timeOffsetInMinutes = -new Date(Date.now()).getTimezoneOffset();
    var userAgent = navigator.userAgent;
    var _document_documentElement = document.documentElement, clientWidth = _document_documentElement.clientWidth, clientHeight = _document_documentElement.clientHeight;
    var URL = document.URL, referrer = document.referrer;
    var address = {
        url: URL,
        referringUrl: referrer
    };
    var renderer = getWebGLRenderer().renderer;
    var channel = "web";
    var colorDepth = screen.colorDepth, height = screen.height, orientation = screen.orientation, width = screen.width;
    var geoLat = Cookies.get("lll_adobe_geo_latitude");
    var geoLong = Cookies.get("lll_adobe_geo_longitude");
    var payload = {
        userAgent: userAgent,
        timeOffsetInMinutes: timeOffsetInMinutes,
        channel: channel,
        screen: {
            colorDepth: colorDepth,
            height: height,
            pixelRatio: window.devicePixelRatio,
            width: width,
            orientation: getOrientation(orientation)
        },
        window: {
            width: clientWidth,
            height: clientHeight
        },
        browser: {
            host: location.hostname,
            webGLRenderer: renderer
        },
        address: address
    };
    if (geoLat !== undefined && geoLong !== undefined) {
        payload = _extends({}, payload, {
            geo: {
                latitude: geoLat,
                longitude: geoLong
            }
        });
    }
    return payload;
};
export { storage, parseQueryString, getContext, getOrientation, getWebGLRenderer };

//# sourceMappingURL=utils.js.map